import { DELETE_FAVORITE,GET_MY_FAVORITES } from '../constants';

export function getMyFavorites(params = {}) {
  return { type: GET_MY_FAVORITES, params };
}

export function deleteFavorite(params = {}) {
  return { type: DELETE_FAVORITE, params };
}
